import { ReactNode } from 'react'

import {
  Button,
  Group,
  LoadingSpinner,
  NetworkLogo,
} from '~/components/component-library'
import { useAuth } from '~/context/AuthProvider'
import { sortChainIds } from '~/utils'

type ActiveNetworksProps = {
  chainIds: number[]
  isLoading?: boolean
  renderDialog: (close: () => void) => ReactNode
}

export const ActiveNetworks = ({
  chainIds,
  isLoading = false,
  renderDialog,
}: ActiveNetworksProps) => {
  const { setGlobalModalState } = useAuth()
  const close = () => setGlobalModalState({ isOpen: false, content: null })

  return (
    <Group
      label="Active networks"
      footer="Account rules and signers will be synced across these networks"
      secondaryDisplay={
        <Button
          variant="secondaryAction"
          onClick={() =>
            setGlobalModalState({ isOpen: true, content: renderDialog(close) })
          }
        >
          Change
        </Button>
      }
    >
      <div className="border border-gray-200 p-3 text-center text-sm text-secondary dark:border-gray-700">
        {isLoading ? (
          <div className="flex justify-center">
            <LoadingSpinner size="xl" thickness="normal" variant="default" />
          </div>
        ) : (
          // Every listed network is pre-enabled and the stack fans out on
          // hover, which overflows this column and a phone screen at `lg`.
          <NetworkLogo chainIds={sortChainIds(chainIds)} size="md" />
        )}
      </div>
    </Group>
  )
}
